<template>
  <div class="vl-userSetting-companyInfo">
    <el-form
      :model="formInline"
      label-width="180px"
      style="width: 80%; margin: 30px auto 0"
    >
      <el-form-item label="企业名称：">
        <span>{{ companyInfo.companyName }}</span>
      </el-form-item>
      <el-form-item label="企业简称：">
        <span>{{ companyInfo.companySimpleName }}</span>
      </el-form-item>
      <el-form-item label="统一社会信用代码：">
        <span>{{ companyInfo.creditCode }}</span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { userSettingGetCompanyInfo } from "@/views/index/api/userSetting/api.userSetting.js";
export default {
  data() {
    return {
      formInline: {},
      companyInfo: {},
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取企业信息
    getInfo() {
      userSettingGetCompanyInfo().then(
        (res) => {
          if (res.code == "00000") {
            this.companyInfo = res.result;
          } else {
            this.$message.error(res.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>
<style lang="scss">
.vl-userSetting-companyInfo {
  .readOnly .el-form-item__label {
    color: #666 !important;
  }
  .readOnly .el-form-item {
    margin-bottom: 18px !important;
  }
}
</style>